import {
  Checkbox,
  FormControl,
  FormLabel,
  FormErrorMessage,
} from '@frontend/legacy-components';

import { NumberValueField } from './NumberInputValue';
import { getFieldError, getFieldTouched } from './formUtils';

type MultiplierInputProps = {
  // Control props
  hasMultFieldName: string;
  hasMult: boolean;
  onHasMultChange: (checked: boolean) => void;

  // Value props
  multFieldName: string;
  multValue?: number | string;
  onMultChange: (value: number | string) => void;

  // Error handling
  errors?: unknown;
  touched?: unknown;

  // Customization
  checkboxLabel?: string;
  inputLabel?: string;
};

export const MultiplierInput = ({
  hasMultFieldName,
  hasMult,
  onHasMultChange,
  multFieldName,
  multValue,
  onMultChange,
  errors,
  touched,
  checkboxLabel = 'Include multiplier',
  inputLabel = 'Multiplier',
}: MultiplierInputProps) => {
  return (
    <>
      {/* Multiplier Checkbox */}
      <Checkbox
        name={hasMultFieldName}
        isChecked={hasMult}
        onChange={(e) => onHasMultChange(e.target.checked)}
        size="sm"
      >
        {checkboxLabel}
      </Checkbox>

      {/* Multiplier Input */}
      {hasMult && (
        <FormControl>
          <FormLabel>{inputLabel}</FormLabel>
          <NumberValueField
            name={multFieldName}
            value={
              typeof multValue === 'string'
                ? multValue
                : multValue?.toString() || ''
            }
            onChange={onMultChange}
            size="sm"
            min={1}
            allowDecimals={false}
          />
          {getFieldError(multFieldName, errors) &&
            getFieldTouched(multFieldName, touched) && (
              <FormErrorMessage>
                {getFieldError(multFieldName, errors)}
              </FormErrorMessage>
            )}
        </FormControl>
      )}
    </>
  );
};
